import { createAction, props } from '@ngrx/store';
import { TableStorageActionModel } from '@models/common/table-storage-action.model';
import { CertificateTypeModel } from '@models/configuration/certificate-type.model';

export const createCertificateType = createAction(
    '[CertificateType] Create CertificateType',
    props<{ action: TableStorageActionModel<CertificateTypeModel> }>()
);

export const createCertificateTypeSuccess = createAction(
    '[CertificateType] Create CertificateType Success',
    props<{ CertificateType: CertificateTypeModel }>()
);

export const searchCertificateTypes = createAction(
    '[CertificateTypes] Search CertificateTypes',
    props<{ action: TableStorageActionModel<CertificateTypeModel> }>()
);

export const searchCertificateTypesSuccess = createAction(
    '[CertificateTypes] Search CertificateTypes Success',
    props<{ CertificateTypes: CertificateTypeModel[] }>()
);

export const updateCertificateType = createAction(
    '[CertificateType] Update CertificateType',
    props<{ action: TableStorageActionModel<CertificateTypeModel> }>()
);

export const updateCertificateTypeSuccess = createAction(
    '[CertificateType] Update CertificateType Success',
    props<{ CertificateType: CertificateTypeModel }>()
);

export const selectCertificateType = createAction(
    '[CertificateType] Select CertificateType',
    props<{ CertificateType: CertificateTypeModel }>()
);

export const deleteCertificateType = createAction(
    '[CertificateType] Delete CertificateType',
    props<{ action: TableStorageActionModel<CertificateTypeModel> }>()
);

export const deleteCertificateTypeSuccess = createAction(
    '[CertificateType] Delete CertificateType Success',
    props<{ CertificateType: CertificateTypeModel }>()
);

export const resetLoading = createAction(
    '[Loading] Reset Loading Success'
);